import { render, staticRenderFns } from "./addTraveller.vue?vue&type=template&id=65a80eb1&scoped=true&"
import script from "./addTraveller.vue?vue&type=script&lang=js&"
export * from "./addTraveller.vue?vue&type=script&lang=js&"
import style0 from "./addTraveller.vue?vue&type=style&index=0&id=65a80eb1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65a80eb1",
  null
  
)

export default component.exports